'use client';

import { __makeTemplateObject, __rest, __assign } from '../_virtual/_tslib.js';
import React__default from 'react';
import styled from 'styled-components';
import Textarea from '../Textarea/index.js';
export { default as ContentEditable } from './ContentEditable/index.js';

var StyledFormField = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    > label {\n        margin-bottom: 4px;\n        display: inline-block;\n\n        > .isRequired {\n            color: #f85a5a;\n        }\n    }\n"], ["\n    > label {\n        margin-bottom: 4px;\n        display: inline-block;\n\n        > .isRequired {\n            color: #f85a5a;\n        }\n    }\n"])));
var TextareaForm = function (_a) {
    var name = _a.name, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.isRequired, isRequired = _c === void 0 ? false : _c, _d = _a.hasError, hasError = _d === void 0 ? false : _d, _e = _a.value, value = _e === void 0 ? '' : _e, onChange = _a.onChange, rest = __rest(_a, ["name", "label", "isRequired", "hasError", "value", "onChange"]);
    return (React__default.createElement(StyledFormField, null,
        label !== '' && (React__default.createElement("label", { htmlFor: name },
            isRequired && React__default.createElement("span", { className: 'isRequired' }, "*"),
            " ",
            label)),
        React__default.createElement(Textarea, __assign({ name: name, value: value, hasError: hasError, onChange: onChange }, rest))));
};
var templateObject_1;

export { TextareaForm };
//# sourceMappingURL=index.js.map
